/* eslint-disable sonarjs/cognitive-complexity */
import { jsx } from 'panel';
import { SelectEl } from 'common/components/select';
import { SvgIconEl } from 'common/components/svg-icon';
import { ButtonBarEl } from 'common/components/button-bar';
import { TooltipEl } from 'common/components/tooltip';
import { Placement } from 'common/components/tooltip/types';
import { ModalEl } from 'common/components/modal';
import { InviteUsersModalEl } from 'common/widgets/invite-users-modal';
import { ToastPortalEl } from 'common/components/toast-portal';
import { LoadEntityModalEl } from 'common/widgets/load-entity-modal';
import { CreateProjectModalEl } from 'common/widgets/create-project-modal';
import { IntroEl } from 'common/widgets/intro';
import { OrganizationIconEl } from 'common/widgets/organization-icon';
import { ProjectFeatureFlag, ReportName } from 'common/report/constants';
import { FestiveMode } from 'common/util/festive-mode';
import { ButtonBarColor } from 'common/components/button-bar/types';
import { NavCategoryType, REPORT_INFO } from './constants';
import { GlobalSearchEl } from './global-search';
import { SupportWidgetEl } from './support-widget';
import { FestiveModeHeaderAnimEl } from './festive-mode-header-anim';
import { ReportsMenuEl } from './reports-menu';
export function template() {
  var _this = this;

  var _a, _b; // don't render any content for download mode


  if (this.isDownloadMode()) {
    return jsx("div", null);
  }

  const {
    categories,
    createProjectError,
    createProjectSelectedOrgId,
    currentCategoryName,
    currentReportName,
    errorAlertMsg,
    inviteModalOrgs,
    isOpen,
    isSupportWidgetMaximized,
    orgData,
    projectId,
    projectMenuWorkspaces,
    searchedText,
    selectedCategory,
    showIntroModal,
    showSupportWidget,
    userStore
  } = this.state;
  const shouldDisplayNavigationOptions = this.helpers.shouldDisplayNavigationOptions();
  const festiveMode = this.helpers.getFestiveMode(); // comes through seasonally, once a quarter

  const currentWorkspace = this.helpers.getCurrentWorkspace();
  const workspaceId = this.currentWorkspaceId;
  const isBoardsUIEnabled = this.helpers.isBoardsUIEnabled();
  const activeReport = currentReportName;
  const reportContext = this.helpers.getReportContext(); // The below const menus are all the menus that appear on the right side of the nav. When we go into the second
  // phase of the nav redesign, the menu order will be different going forward. It would be better to reference
  // them via constants rather than menu copy pasta, hence this change.

  const dataManagementMenu = jsx("div", {
    sel: '.mp-chrome-header-trigger-container.mp-chrome-header-trigger-container-data-management',
    class: {
      'mp-chrome-header-trigger-container-active': this.helpers.isActiveCategory(activeReport, NavCategoryType.DataManagement, isOpen.dataManagementMenu)
    },
    on: {
      click: () => this.helpers.selectMenuChanged("dataManagement", !isOpen.dataManagementMenu)
    }
  }, isOpen.dataManagementMenu ? jsx(ReportsMenuEl, {
    attrs: {
      'current-report-name': currentReportName,
      'project-id': projectId,
      'two-column': false,
      reports: JSON.stringify(this.helpers.getNavReportsFromCategory(NavCategoryType.DataManagement)),
      order: JSON.stringify(Object.keys(this.helpers.getNavReportsFromCategory(NavCategoryType.DataManagement))),
      open: true,
      'workspace-id': workspaceId
    },
    on: {
      closemenu: () => this.helpers.handleCategoryCloseMenu("dataManagementMenu")
    }
  }) : null, jsx("div", {
    sel: '.mp-chrome-header-trigger-container-icon'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "brand-data-management"
    }
  })), this.helpers.allMenusClosed() ? jsx(TooltipEl, {
    attrs: {
      placement: Placement.Bottom
    }
  }, "Data Management") : null);
  const messagesMenu = jsx("div", {
    sel: '.mp-chrome-header-trigger-container.mp-chrome-header-trigger-container-messages',
    class: {
      'mp-chrome-header-trigger-container-active': this.helpers.isActiveCategory(activeReport, NavCategoryType.MessagesAndExperiments, isOpen.messagesMenu)
    },
    on: {
      click: () => this.helpers.selectMenuChanged("messages", !isOpen.messagesMenu)
    }
  }, isOpen.messagesMenu ? jsx(ReportsMenuEl, {
    attrs: {
      'current-report-name': currentReportName,
      'project-id': projectId,
      'two-column': false,
      reports: JSON.stringify(this.helpers.getNavReportsFromCategory(NavCategoryType.MessagesAndExperiments)),
      order: JSON.stringify(Object.keys(this.helpers.getNavReportsFromCategory(NavCategoryType.MessagesAndExperiments))),
      open: true,
      'workspace-id': workspaceId
    },
    on: {
      closemenu: () => this.helpers.handleCategoryCloseMenu("messagesMenu")
    }
  }) : null, jsx("div", {
    sel: '.mp-chrome-header-trigger-container-icon'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "brand-messages"
    }
  })), this.helpers.allMenusClosed() ? jsx(TooltipEl, {
    attrs: {
      placement: Placement.Bottom
    }
  }, "Messages") : null);
  const helpMenu = jsx("div", {
    sel: '.mp-chrome-header-trigger-container.mp-chrome-header-trigger-container-help',
    class: {
      'mp-chrome-header-trigger-container-active': isOpen.helpMenu
    }
  }, jsx(SelectEl, {
    attrs: {
      elref: "helpMenu",
      'menu-width': 256,
      icon: "brand-help",
      'icon-only': true,
      'menu-height': 400
    },
    props: {
      sectionsFn: () => this.helpers.getHelpMenuSections()
    },
    on: {
      change: this.helpers.helpMenuItemSelected,
      menuChange: ev => this.helpers.selectMenuChanged("help", ev.detail.isOpen)
    }
  }, jsx("div", {
    sel: '.mp-chrome-header-trigger-container-icon',
    class: {
      'mp-chrome-header-trigger-container-notif': this.helpers.shouldShowHelpMenuNotif()
    },
    attrs: {
      slot: "trigger"
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "brand-help"
    }
  }))), this.helpers.allMenusClosed() ? jsx(TooltipEl, {
    attrs: {
      placement: Placement.Bottom
    }
  }, "Help") : null);
  const applicationMenu = jsx("div", {
    sel: '.mp-chrome-header-trigger-container',
    class: {
      'mp-chrome-header-trigger-container-active': this.helpers.isActiveCategory(activeReport, NavCategoryType.Applications, isOpen.applicationsMenu)
    }
  }, jsx(SelectEl, {
    attrs: {
      elref: "applicationsMenu",
      'search-threshold': 10,
      'menu-width': 300,
      'menu-height': 400
    },
    props: {
      sectionsFn: () => this.helpers.getApplicationsMenuSections()
    },
    on: {
      change: this.helpers.menuItemSelected,
      menuChange: ev => this.helpers.selectMenuChanged("applications", ev.detail.isOpen)
    }
  }, jsx("div", {
    sel: '.mp-chrome-header-trigger-container-icon',
    attrs: {
      slot: "trigger"
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "brand-applications"
    }
  }))), this.helpers.allMenusClosed() ? jsx(TooltipEl, {
    attrs: {
      placement: Placement.Bottom
    }
  }, "Applications") : null);
  const settingsMenu = jsx("div", {
    sel: '.mp-chrome-header-trigger-container',
    class: {
      'mp-chrome-header-trigger-container-active': this.helpers.isActiveCategory(activeReport, NavCategoryType.Settings, isOpen.setupMenu)
    }
  }, jsx(SelectEl, {
    attrs: {
      elref: "settingsMenu",
      'disable-search': true,
      'menu-width': 280,
      'menu-height': 480
    },
    props: {
      sectionsFn: () => this.helpers.getSettingsMenuSections()
    },
    on: {
      change: this.helpers.menuItemSelected,
      menuChange: ev => this.helpers.selectMenuChanged("setup", ev.detail.isOpen)
    }
  }, jsx("div", {
    sel: '.mp-chrome-header-trigger-container-icon',
    attrs: {
      slot: "trigger"
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "brand-settings"
    }
  }))), jsx(TooltipEl, {
    attrs: {
      placement: Placement.Bottom
    },
    style: {
      display: this.helpers.allMenusClosed() ? "" : "none"
    }
  }, "Settings"));
  const projectMenu = jsx("div", {
    sel: '.mp-chrome-project-menu-container'
  }, (() => {
    var _a, _b;

    const displayWorkspaceSelection = this.helpers.areWorkspacesActivated();
    const projectsLength = this.helpers.getProjectsForMenu().length;
    return jsx(SelectEl, {
      attrs: {
        elref: "projectsMenu",
        'search-placeholder': displayWorkspaceSelection ? "Search data views" : "Search projects",
        'menu-width': 300,
        'menu-height': 400,
        'back-button': displayWorkspaceSelection,
        'header-title': displayWorkspaceSelection ? "Data Views (".concat(projectMenuWorkspaces.length, ")") : "Projects (".concat(projectsLength, ")")
      },
      props: {
        sectionsFn: () => this.helpers.getProjectsMenuSections(),
        contextPanelTransform: this.helpers.getProjectOrWorkspaceContextPanelData
      },
      on: {
        backClick: this.helpers.selectProjectMenuBackClick,
        change: this.helpers.selectProjectMenuItem,
        menuChange: ev => this.helpers.selectMenuChanged("project", ev.detail.isOpen)
      },
      class: {
        'mp-chrome-project-menu-active': this.helpers.isActiveCategory(activeReport, NavCategoryType.Project, isOpen.projectMenu)
      }
    }, jsx("div", {
      sel: '.mp-chrome-project-menu-btn',
      attrs: {
        slot: "trigger"
      }
    }, jsx("div", {
      sel: '.mp-chrome-project-menu-label-container'
    }, jsx("div", {
      sel: '.mp-chrome-project-menu-label',
      attrs: {
        title: this.helpers.getProjectAndWorkspaceName(
        /*truncated*/
        false)
      }
    }, jsx(null, null, jsx("div", {
      sel: '.mp-chrome-project-menu-label-project'
    }, ((_a = this.currentProject) === null || _a === void 0 ? void 0 : _a.name) || "Loading ..."), jsx("div", {
      sel: '.mp-chrome-project-menu-label-workspace'
    }, ((_b = this.helpers.getCurrentWorkspace()) === null || _b === void 0 ? void 0 : _b.name) || ""))), jsx(SvgIconEl, {
      sel: '.mp-chrome-categories-label-filled-icon',
      attrs: {
        icon: "caret-down"
      }
    }))), displayWorkspaceSelection ? this.helpers.getUserHasCreateWorkspacePermission() ? jsx("div", {
      sel: '.mp-chrome-project-menu-add',
      attrs: {
        slot: "footer"
      }
    }, jsx(ButtonBarEl, {
      attrs: {
        color: ButtonBarColor.Grey
      },
      on: {
        click: this.helpers.handleCreateWorkspaceBtnClick
      }
    }, jsx("div", {
      sel: '.mp-chrome-project-menu-button-bar-text'
    }, "Create Data View"))) : null : // do not show add project dialog for org members unless they have perms
    jsx("div", {
      sel: '.mp-chrome-project-menu-add',
      attrs: {
        slot: "footer"
      }
    }, orgData.length && (!orgData[0].id || this.helpers.getOrgsWithCreateProjectPermission().length) ? jsx(ButtonBarEl, {
      attrs: {
        color: ButtonBarColor.Grey
      },
      on: {
        click: this.helpers.clickedCreateProject
      }
    }, jsx("div", {
      sel: '.mp-chrome-project-menu-button-bar-text'
    }, "Create Project")) : null));
  })());
  const usersButton = jsx("div", {
    sel: '.mp-chrome-header-trigger-container.mp-chrome-header-trigger-container-users',
    class: {
      'mp-chrome-header-trigger-container-active': currentReportName === ReportName.Explore
    }
  }, jsx("div", {
    sel: '.mp-chrome-header-trigger-container-icon'
  }, jsx("a", {
    attrs: {
      href: this.helpers.getReportUrl(ReportName.Explore, {
        projectId,
        workspaceId
      })
    },
    on: {
      click: () => this.helpers.handleClickReportName(ReportName.Explore, "Top Nav")
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "team"
    }
  }))), jsx(TooltipEl, {
    attrs: {
      placement: Placement.Bottom
    }
  }, "Users"));

  const getChromeReport = (report, label) => jsx("a", {
    sel: '.mp-chrome-categories-category',
    attrs: {
      href: this.helpers.getReportUrl(report, {
        projectId,
        workspaceId
      }),
      isActiveCategory: report === currentReportName,
      elref: "chromeCategory".concat(label)
    },
    on: {
      click: () => this.helpers.handleClickReportName(report, "Top Nav")
    },
    class: {
      'mp-chrome-categories-category-active': this.helpers.isActiveCategory(activeReport, REPORT_INFO[report].category(reportContext), false)
    }
  }, jsx("div", {
    sel: '.mp-chrome-categories-label-container'
  }, jsx("div", {
    sel: '.mp-chrome-categories-label'
  }, label)));

  const getChromeCategory = function getChromeCategory(category) {
    let name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    const isActiveCategory = category.name === selectedCategory;
    const reportsMenuOpen = category.reports && isActiveCategory;
    return jsx(null, null, jsx("div", {
      sel: '.mp-chrome-categories-category',
      attrs: {
        elref: "chromeCategory".concat(category.name)
      },
      class: {
        'mp-chrome-categories-category-active': isActiveCategory
      },
      on: {
        click: () => _this.helpers.toggleSelectedCategory(category.name)
      }
    }, jsx("div", {
      sel: '.mp-chrome-categories-label-container'
    }, jsx(null, null, jsx("div", {
      sel: '.mp-chrome-categories-label'
    }, name || category.label), jsx(SvgIconEl, {
      sel: '.mp-chrome-categories-label-filled-icon',
      attrs: {
        icon: "caret-down"
      }
    }), reportsMenuOpen ? jsx(ReportsMenuEl, {
      attrs: {
        'current-report-name': currentReportName,
        'project-id': projectId,
        'two-column': !!category.twoColumn,
        reports: JSON.stringify(category.reports),
        order: JSON.stringify(category.order || Object.keys(category.reports)),
        open: true,
        'workspace-id': workspaceId
      },
      class: {
        'mp-chrome-categories-label-report-menu-new-nav': true
      },
      on: {
        closemenu: () => _this.update({
          selectedCategory: ""
        })
      }
    }) : null))));
  };

  return jsx("div", {
    sel: '.mp-chrome-header',
    class: {
      'mp-chrome-header-root': true,
      'mp-chrome-header-hidden': this.attr("hidden")
    },
    hook: !this.attr("hidden") ? this.helpers.stickyElemHooks : {}
  }, jsx("div", {
    sel: '.mp-chrome-header-row-primary',
    class: {
      'mp-chrome-header-festive-mode': !!festiveMode
    }
  }, !((_a = this.currentProject) === null || _a === void 0 ? void 0 : _a.organizationId) ? null : jsx("div", {
    sel: '.mp-chrome-header-inner'
  }, festiveMode === FestiveMode.Luv ? jsx(FestiveModeHeaderAnimEl, null) : null, projectId ? jsx("div", {
    sel: '.mp-chrome-header-left'
  }, jsx(null, null, jsx("a", {
    sel: '.mp-chrome-header-left-avatar',
    attrs: {
      href: this.helpers.getReportUrl(ReportName.Dashboards, {
        projectId,
        workspaceId
      })
    },
    on: {
      click: () => this.helpers.handleClickReportName(ReportName.Dashboards, "Home")
    }
  }, jsx(OrganizationIconEl, {
    attrs: {
      title: "Home"
    }
  })), jsx("div", {
    sel: '.mp-chrome-categories-container'
  }, !isBoardsUIEnabled && jsx(null, null, getChromeReport(ReportName.Dashboards, NavCategoryType.Dashboards), getChromeCategory(categories ? categories["analysis"] : {
    label: NavCategoryType.Analysis,
    name: "analysis",
    reports: {}
  }, "Reports"), getChromeReport(ReportName.Explore, NavCategoryType.Users))))) : null, shouldDisplayNavigationOptions ? jsx("div", {
    sel: '.mp-chrome-header-center',
    attrs: {
      elref: "chromeHeaderCenter"
    }
  }, jsx("div", {
    sel: '.mp-chrome-categories-container'
  }, jsx("div", {
    sel: '.mp-chrome-categories-container-search'
  }, jsx(GlobalSearchEl, {
    sel: '.mp-chrome-header-trigger-container-search',
    attrs: {
      open: isOpen.searchMenu
    },
    on: {
      menuChange: this.helpers.handleSearchMenuChange,
      entitySelected: ev => this.helpers.navigate(ev.detail.href),
      searchTermSelected: this.helpers.handleSearchTermSelected,
      browseAllSelected: this.helpers.handleBrowseAllSelected
    }
  }), jsx("div", {
    sel: '.mp-chrome-categories-search-button',
    class: {
      'mp-chrome-categories-search-dropdown-open': isOpen.searchMenu
    },
    on: {
      click: () => this.helpers.selectMenuChanged("search", true)
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "search"
    },
    sel: '.mp-chrome-categories-search-icon'
  }), jsx("span", {
    sel: '.mp-chrome-categories-search-text'
  }, searchedText ? "Search: ".concat(searchedText) : "Search Dashboards & Reports ".concat(this.helpers.getSearchShortcutDisplayName())))))) : null, jsx("div", {
    sel: '.mp-chrome-header-right'
  }, isBoardsUIEnabled && usersButton, shouldDisplayNavigationOptions ? dataManagementMenu : null, shouldDisplayNavigationOptions && this.helpers.hideMessagesMenu() ? null : messagesMenu, shouldDisplayNavigationOptions && this.helpers.featuresStoreHasValue() && !this.helpers.hasProjectFeatureFlag(ProjectFeatureFlag.HideMenuApps) ? applicationMenu : null, helpMenu, settingsMenu, projectMenu))), this.helpers.shouldShowSecondaryHeader() ? jsx("div", {
    sel: '.mp-chrome-header-row-secondary'
  }, jsx("div", {
    sel: '.mp-chrome-header-row-secondary-inner'
  }, jsx("div", {
    sel: '.mp-chrome-reports-container'
  }, Object.values(((_b = categories[currentCategoryName]) === null || _b === void 0 ? void 0 : _b.reports) || {}).map(report => jsx("a", {
    sel: '.mp-chrome-reports-report',
    class: {
      'mp-chrome-reports-report-selected': report.name === currentReportName
    },
    attrs: {
      href: this.helpers.getReportUrl(report.endpoint, {
        projectId,
        workspaceId
      })
    },
    on: {
      click: () => this.helpers.handleClickReportName(report.name, "Sub Nav")
    }
  }, report.label))))) : null, errorAlertMsg && jsx(ToastPortalEl, {
    props: {
      toast: {
        isStatic: true,
        type: "error",
        message: errorAlertMsg,
        closeToastCallback: this.helpers.handleErrorToastClosed
      }
    }
  }), createProjectError && jsx(ToastPortalEl, {
    props: {
      toast: {
        isStatic: true,
        type: "error",
        message: "Failed to create new project. Error: ".concat(createProjectError)
      }
    }
  }), orgData.length && isOpen.createProjectModal ? jsx(CreateProjectModalEl, {
    attrs: {
      open: true,
      orgs: orgData,
      'organization-id': createProjectSelectedOrgId
    },
    on: {
      cancel: this.helpers.clickedCancel,
      create: this.helpers.clickedCreate
    }
  }) : null, isOpen.inviteModal ? jsx(InviteUsersModalEl, {
    attrs: {
      open: true
    },
    props: {
      orgs: inviteModalOrgs
    },
    on: {
      save: this.helpers.closeInviteModal,
      cancel: this.helpers.closeInviteModal,
      notify: this.helpers.handleNotify,
      error: this.helpers.handleError
    }
  }) : null, isOpen.searchModal ? jsx(LoadEntityModalEl, {
    attrs: {
      open: true,
      'modal-title': "Open Report",
      'empty-message': "You don't have any saved entities yet.",
      'project-id': projectId,
      'track-name': "Content Discovery",
      'search-text': searchedText,
      'user-id': userStore.value.id,
      'workspace-id': currentWorkspace ? currentWorkspace.id : 0
    },
    on: {
      close: this.helpers.handleSearchModalClose
    }
  }) : null, showSupportWidget ? jsx(SupportWidgetEl, {
    attrs: this.helpers.supportWidgetAttrs(),
    on: {
      close: this.helpers.closeSupportWidget,
      maximize: this.helpers.handleSupportWidgetMaximize
    },
    props: {
      maximize: isSupportWidgetMaximized
    }
  }) : null, showIntroModal ? jsx(ModalEl, {
    attrs: {
      elref: "introModal",
      closeable: true,
      open: showIntroModal,
      'grow-to-content': true
    },
    on: {
      change: ev => this.helpers.onIntroModalChange(ev)
    }
  }, jsx(IntroEl, {
    attrs: {
      'first-name': (userStore.value.name || "").split(" ")[0]
    },
    on: {
      close: this.helpers.closeIntroModal
    }
  })) : null);
}